
















import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';

import store from '@/store/store';
import { getModule } from 'vuex-module-decorators';
import { INotification, User, Entry } from '../../types';

@Component
export default class LikeNotification extends Vue {
  @Prop(Object) notif: INotification;

  user = {};

  get target() {
    switch (this.notif.data.target) {
      case 'transcription':
        return this.$t('notification.transcription');
        break;
      case 'post':
        return this.$t('notification.comment');
        break;
    }
  }

  async created() {
    this.user = await this.$db.getUserData(this.notif.data.uid);
  }

  jump() {
    this.$router.push({
      name: 'transcription.history',
      params: {
        entryId: this.notif.data.entryId,
        page: this.notif.data.index + 1,
      },
    });
  }
}
